<template>
    <div class="checkout-body">
        <section class="builder-header layout-row">
            <div class="konf-logo">
                <router-link to="/">
                    <img src="@/assets/img/motolino-logo-stroke.svg" alt="Motolino konfigurator" v-if="logo === null" />
                    <img v-bind:src="'data:image/jpeg;base64,'+logo" v-if="logo !== null" :alt="dealerName" />
                </router-link>
            </div>
            <div :class="['dark-layout', { show: cartOpen }]" @click="cartOpen = false"></div>
            <div class="total-header" @click="cartOpen = true">
                <img src="@/assets/img/checkout/check.svg" alt=""/>
                <div class="value">{{ price(subtotal) }}</div>
            </div>
        </section>
        <div class="checkout-body__inner">
            <div class="layout-column center flex mt-30">
                <div class="checkout-form mt-30 review-form" v-if="checkoutComplete">
                    <div class="checkout-success-top">
                        <img src="@/assets/img/checkout/scooter.svg" alt=""/>
                        <h2 class="success-title">Herzlichen Glückwunsch. Wir haben Ihre Bestellung erhalten</h2>
                        <p class="above-title">Sie erhalten eine Bestellbestätigung per E-Mail.</p>
                    </div>
                    <div class="buttons__wrapper">
                        <router-link to="/" class="button-green">
                            Zurück zum Start (Redirect in {{redirectInS}}s)
                        </router-link>
                    </div>
                </div>
            </div>
            <template v-if="!checkoutComplete">
                <div class="layout-column center flex mt-30">
                    <div class="layout-row mb-40">
                        <div class="checkout-body__left" v-if="loading">
                            <Spinner/>
                        </div>
                        <div v-if="!loading">
                            <div class="checkout-form">
                                <h4>Rechnungsadresse</h4>

                                <div class="row-cards">
                                    <div class="input-wrapper input-single-row flex">
                                        <span>Vorname</span>
                                        <input placeholder="vorname" type="text" v-model="checkoutData.firstName"
                                               required/>
                                        <small v-if="v$.firstName.$invalid && v$.firstName.$dirty" class="form-error">
                                            Bitte geben Sie einen Vornamen an
                                        </small>
                                    </div>
                                    <div class="input-wrapper input-single-row flex">
                                        <span>Nachname</span>
                                        <input placeholder="Nachname" type="text" v-model="checkoutData.lastName"
                                               required/>
                                        <small v-if="v$.lastName.$invalid && v$.lastName.$dirty" class="form-error">
                                            Bitte geben Sie einen Nachnamen an
                                        </small>
                                    </div>
                                </div>

                                <div class="row-cards">
                                    <div class="input-wrapper input-single-row">
                                        <span>Strasse</span>
                                        <input placeholder="Strasse" type="text" v-model="checkoutData.street"
                                               required/>
                                        <small v-if="v$.street.$invalid && v$.street.$dirty" class="form-error">
                                            Bitte geben Sie eine Strasse an
                                        </small>
                                    </div>
                                    <div class="input-wrapper input-single-row form-input-small">
                                        <span>Nr.</span>
                                        <input placeholder="Nr." type="text" v-model="checkoutData.streetNr" required/>
                                        <small v-if="v$.street.$invalid && v$.streetNr.$dirty" class="form-error">
                                            Bitte geben Sie eine Strassennummer an
                                        </small>
                                    </div>
                                </div>
                                <div class="row-cards">
                                    <div class="input-wrapper input-single-row form-input-small">
                                        <span>Postleitzahl</span>
                                        <input placeholder="Postleitzahl" type="text" v-model="checkoutData.zipCode"
                                               required/>
                                        <small v-if="v$.zipCode.$invalid && v$.zipCode.$dirty" class="form-error">
                                            Bitte geben Sie eine Postleitzahl an
                                        </small>
                                    </div>
                                    <div class="input-wrapper input-single-row">
                                        <span>Ort</span>
                                        <input placeholder="Ort" type="text" v-model="checkoutData.city" required/>
                                        <small v-if="v$.city.$invalid && v$.city.$dirty" class="form-error">
                                            Bitte geben Sie einen Ort an
                                        </small>
                                    </div>
                                </div>
                                <div class="row-cards">
                                    <div class="input-wrapper input-single-row">
                                        <span>Zahlung</span>
                                        <Dropdown v-model="checkoutData.paymentMethod" :options="['Bar', 'Banküberweisung', 'Leasing']" />
                                        <small v-if="v$.paymentMethod.$invalid && v$.paymentMethod.$dirty" class="form-error">
                                            Bitte wählen Sie eine Zahlmethode aus
                                        </small>
                                    </div>
                                </div>
                                <h4 class="mt-30">Kontaktdaten</h4>
                                <div class="row-cards">
                                    <div class="input-wrapper input-single-row">
                                        <span>Email</span>
                                        <input placeholder="Email" type="email" v-model="checkoutData.email" required/>
                                        <small v-if="v$.email.$invalid && v$.email.$dirty" class="form-error">
                                            Bitte geben Sie eine Email an
                                        </small>
                                    </div>
                                    <div class="input-wrapper input-single-row">
                                        <span>Telefon</span>
                                        <input placeholder="Telefon" type="tel" v-model="checkoutData.phone" required/>
                                        <small v-if="v$.phone.$invalid && v$.phone.$dirty" class="form-error">
                                            Bitte geben Sie eine Telefonnummer an
                                        </small>
                                    </div>
                                </div>
                                <div class="buttons__wrapper mobile">
                                    <button class="button-green" @click="submitForm">
                                        <div class="hover-arr">
                                            <img src="@/assets/img/icons/check-white.svg" alt=""/>
                                            <img src="@/assets/img/icons/check-green.svg" class="hovered" alt=""/>
                                        </div>
                                        Bestellung absenden
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="cart-form" v-if="!loading">
                            <h4 class="cart-title-desktop">Deine Auswahl</h4>
                            <Cart :open="cartOpen" @close="cartOpen = false"/>
                            <div class="buttons__wrapper">
                                <button class="button-green" @click="submitForm">
                                    <div class="hover-arr">
                                        <img src="@/assets/img/icons/check-white.svg" alt=""/>
                                        <img src="@/assets/img/icons/check-green.svg" class="hovered" alt=""/>
                                    </div>
                                    Bestellung absenden
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

            </template>
        </div>
    </div>
</template>

<script>
import State from '@/state/Checkout';
import Dealer from '@/state/Dealership';
import { price } from '@/services/Formatters';
import Cart from '../components/Checkout/Cart';
import Spinner from '../components/Common/Spinner';
import { email, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { inject, ref } from 'vue';
import axios from 'axios';
import { Al } from '../helpers/async.helper';
import { useRouter } from 'vue-router'

export default {
    components: { Cart, Spinner },
    inject: [ 'rator', 'user', 'cart' ],
    setup() {
        const cart = inject('cart');
        const checkoutData = ref({});
        const checkoutComplete = ref(false);
        const redirectInS = ref(5);
        const router = useRouter();
        const rator = inject('rator');

        const rules = {
            firstName: {
                required
            },
            lastName: {
                required
            },
            street: {
                required
            },
            streetNr: {
                required
            },
            zipCode: {
                required
            },
            city: {
                required
            },
            email: {
                required, email
            },
            phone: {
                required
            },
            paymentMethod: {
                required
            }
        };
        const v$ = useVuelidate(rules, checkoutData);
        const submitForm = async () => {
            await v$.value.$validate();
            if (!v$.value.$invalid) {
                checkoutData.value.items = cart.items;
                const result = await Al(axios.post(`${process.env.VUE_APP_API_BASEURL}/checkout`, checkoutData.value, { headers: { 'X-Digitalino-Merchant': Dealer.getMerchantId() } }));
                if (result.status === 200) {
                    checkoutComplete.value = true;
                    cart.empty();
                    rator.reset();

                    let intervalId;
                    intervalId = setInterval(() => {
                        if (redirectInS.value > 0) --redirectInS.value;

                        if (intervalId && redirectInS.value === 0) {
                            clearInterval(intervalId);
                            router.push("/");
                        }

                    }, 1000)
                }
            }
        }

        return { v$, submitForm, checkoutData, checkoutComplete, redirectInS }
    },
    data: () => ({
        loading: true,
        state: State,
        cartOpen: false,
    }),
    provide() {
        return this.state;
    },
    mounted() {
        this.init();
    },
    unmounted() {
        if (this.state.status.completed)
            this.state.reset();
    },
    methods: {
        price,
        async init() {
            this.loading = true;

            if (this.user.authed.value)
                await this.state.init();

            this.loading = false;
        }
    },
    computed: {
        step() {
            return this.$route.params.step || (this.user.authed.value ? 'shipping' : 'start');
        },
        subtotal() {
            const items = this.state.status.completed ? this.state.order : this.cart.items;

            return items.reduce((a, b) => a + b.price * b.qty, 0);
        },
        logo() {
            return Dealer.getImage();
        },
        dealerName() {
            return Dealer.getName();
        }
    },
    watch: {
        '$route.params.step'() {
            window.scrollTo(0, 0);
        }
    }
};
</script>


<style src="@/assets/scss/views/Checkout.scss" lang="scss"></style>
